import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../Model/Common/common.service';
import { UserMasterService } from '../user-master.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { UserApplicabilityFilterComponent } from '../user-applicability-filter/user-applicability-filter.component';
import { ApprovalMatrixService } from '../Model/ApprovalMatrix/approval-matrix.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';

@Component({
  selector: 'app-separation-policy',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule, FormsModule, NgSelectModule],
  templateUrl: './separation-policy.component.html',
  styleUrl: './separation-policy.component.scss'
})
export class SeparationPolicyComponent {

  isDisabled: boolean = false;

  constructor(
    protected tooltip: TooltipService,
    protected common: CommonService,
    private userMasterService: UserMasterService,
    private modalService: NgbModal,
    private approvalMatrix: ApprovalMatrixService,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.ComboLoad('UserMasterForUserApplicability');
    this.ComboLoad('ApplicabilityMaster');
  }

  allowBackdateSeparation: boolean = false;
  policybasedon = 'Month';

  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;
  Applicabilitys = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  Regions = [] as any;
  RegionsFilter = [] as any;
  Zone = [] as any;
  ZoneFilter = [] as any;
  IndustrySegment = [] as any;
  IndustrySegmentFilter = [] as any;
  LastWebESSUserApplicabilityMasterID = null;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;
  User: any;

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.userMasterService.ComboLoad({
      'SelectType': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'UserMasterForUserApplicability') {
          this.Users = response.Table;
          this.isDisabled = false;
        }
        else if (Combotype == 'ApplicabilityMaster') {
          this.Applicabilitys = response.Table;
          this.isDisabled = false;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }

  ShiftRuleDetail = {
    SelectType: '',
    WebESSUserAccessControlMasterID: 0,
    WebESSUserApplicabilityMasterID: null as any,
    MappedId: null as any,
    UserMasterID: null as any,
    EmpType: 'FRONT'
  }

  Filter = {
    BranchID: null,
    ClientID: null,
  }

  ApprovalComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.userMasterService.ComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID
    }).subscribe({
      next: (response) => {
        if (Combotype == 'CompanyMasterForUserApplicability') {
          // this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterID));
          // this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterID));

          this.Companys = response.Table;
          this.CompanysFilter = response.Table;

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterID,
                ApplicabilityData: element.CompanyName,
                WebESSUserApplicabilityMasterID: this.ShiftRuleDetail.WebESSUserApplicabilityMasterID,
                IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'BranchMasterForUserApplicability') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSUserApplicabilityMasterID: this.ShiftRuleDetail.WebESSUserApplicabilityMasterID,
                IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'ClientMasterForUserApplicability') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ClientGroupMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ClientGroupMasterID,
                  ApplicabilityData: element.ClientGroupName,
                  WebESSUserApplicabilityMasterID: this.ShiftRuleDetail.WebESSUserApplicabilityMasterID,
                  IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'SiteMasterForUserApplicability') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteName,
                  WebESSUserApplicabilityMasterID: this.ShiftRuleDetail.WebESSUserApplicabilityMasterID,
                  IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'RegionMasterForUserApplicability') {

          this.Regions = response.Table;
          this.RegionsFilter = response.Table;

          this.Regions.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.RegionMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.RegionMasterID,
                  ApplicabilityData: element.RegionName,
                  WebESSUserApplicabilityMasterID: this.ShiftRuleDetail.WebESSUserApplicabilityMasterID,
                  IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.RegionMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'ZoneMasterForUserApplicability') {

          this.Zone = response.Table;
          this.ZoneFilter = response.Table;

          this.Zone.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ZoneMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ZoneMasterID,
                  ApplicabilityData: element.ZoneName,
                  WebESSUserApplicabilityMasterID: this.ShiftRuleDetail.WebESSUserApplicabilityMasterID,
                  IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.ZoneMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'IndustrySegmentMasterForUserApplicability') {
          this.IndustrySegment = response.Table;
          this.IndustrySegmentFilter = response.Table;

          this.IndustrySegment.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.IndustrySegmentID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.IndustrySegmentID,
                  ApplicabilityData: element.IndustrySegmentName,
                  WebESSUserApplicabilityMasterID: this.ShiftRuleDetail.WebESSUserApplicabilityMasterID,
                  IsCheck: this.ShiftRuleDetail.MappedId != null ? this.ShiftRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.IndustrySegmentID) >= 0 ? true : false : false,
                }
              );
            }
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.ShiftRuleDetail.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.ShiftRuleDetail.MappedId = null;
        this.LastWebESSUserApplicabilityMasterID = this.ShiftRuleDetail.WebESSUserApplicabilityMasterID;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 1) {
        this.ApprovalComboLoad('CompanyMasterForUserApplicability');
      } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 2) {
        this.ApprovalComboLoad('BranchMasterForUserApplicability');
      }
      // else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 3) {
      //   this.ApprovalComboLoad('ClientMasterForUserApplicability');
      // } 
      else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 4) {
        this.ApprovalComboLoad('RegionMasterForUserApplicability');
      } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 5) {
        this.ApprovalComboLoad('ZoneMasterForUserApplicability');
      } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 6) {
        this.ApprovalComboLoad('IndustrySegmentMasterForUserApplicability');
      }
      // else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 7) {
      //   this.ApprovalComboLoad('SiteMasterForUserApplicability');
      // }
      else {
        if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID != 0) {
          this.FilterForm();
        }
      }
    }
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSUserApplicabilityMasterID != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.ShiftRuleDetail.WebESSUserApplicabilityMasterID = this.LastWebESSUserApplicabilityMasterID;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  FilterForm() {
    const modalRef = this.modalService.open(UserApplicabilityFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 3 ? 'Client' : this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 7 ? 'Site' : '';
    modalRef.componentInstance.WebESSUserApplicabilityMasterID = this.ShiftRuleDetail.WebESSUserApplicabilityMasterID;
    modalRef.componentInstance.EmpType = this.ShiftRuleDetail.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 3 || this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 7) ? true : false,
      ShowClient: (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 7) ? true : false,
    }
    modalRef.result.then(result => {
      console.log(result);
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 1) {
        this.ApprovalComboLoad('CompanyMasterForUserApplicability');
      } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 2) {
        this.ApprovalComboLoad('BranchMasterForUserApplicability');
      } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 3) {
        this.ApprovalComboLoad('ClientMasterForUserApplicability');
      } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 4) {
        this.ApprovalComboLoad('RegionMasterForUserApplicability');
      } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 5) {
        this.ApprovalComboLoad('ZoneMasterForUserApplicability');
      } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 6) {
        this.ApprovalComboLoad('IndustrySegmentMasterForUserApplicability');
      } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 7) {
        this.ApprovalComboLoad('SiteMasterForUserApplicability');
      }
    });
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.ShiftRuleDetail.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (response.Table.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0) >= 0) {
          this.Applicabilitys.push(response.Table.filter((e: any) => e.WebESSApplicabilityMasterID == 0)[0]);
          this.Applicabilitys.splice(this.Applicabilitys.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0), 1);
        }
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.ShiftRuleDetail.WebESSUserApplicabilityMasterID).length == 0) {
          this.ShiftRuleDetail.WebESSUserApplicabilityMasterID = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetApplicabilityAccess() {
    this.ApplicabilityDatas = [];
    this.isDisabled = true;
    this.userMasterService.LoadApplicability({
      SelectType: 1,
      UserMasterID: this.ShiftRuleDetail.UserMasterID,
    }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.ShiftRuleDetail.WebESSUserApplicabilityMasterID = response.Table[0].WebESSUserApplicabilityMasterId;
        }
        if (response.Table1.length > 0) {
          this.ShiftRuleDetail.MappedId = response.Table1.map((obj: any) => obj.MappedId).join(",");
        }

        console.log(this.ShiftRuleDetail.MappedId);

        if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 1) {
          this.ApprovalComboLoad('CompanyMasterForUserApplicability');
        } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 2) {
          this.ApprovalComboLoad('BranchMasterForUserApplicability');
        } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 3) {
          this.ApprovalComboLoad('ClientMasterForUserApplicability');
        } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 4) {
          this.ApprovalComboLoad('RegionMasterForUserApplicability');
        } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 5) {
          this.ApprovalComboLoad('ZoneMasterForUserApplicability');
        } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 6) {
          this.ApprovalComboLoad('IndustrySegmentMasterForUserApplicability');
        } else if (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 7) {
          this.ApprovalComboLoad('SiteMasterForUserApplicability');
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
      if (
        (id == 3 || id == 7) ||
        (id == 0 && (this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 3 || this.ShiftRuleDetail.WebESSUserApplicabilityMasterID == 7))) {
        this.ApplicabilityDataFilter(true);
      } else {
        this.toast.show({ message: "Filter only allow for client and site.", type: toastTypeEnum.warning });
      }
    }

}
